import { Link } from 'react-router-dom'
import { styled } from 'styled-system/jsx'

const Nav = styled('header', {
  base: {
    position: 'sticky',
    top: 0,
    zIndex: 50,
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    backdropFilter: 'saturate(180%) blur(12px)',
    borderBottom: '1px solid',
    borderColor: 'app.border',
  },
})

const NavInner = styled('div', {
  base: {
    maxWidth: '1180px',
    margin: '0 auto',
    paddingX: { base: '16px', md: '32px' },
    height: { base: '64px', md: '72px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
})

const LogoLink = styled(Link, {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: 700,
    color: 'app.fg',
    textDecoration: 'none',
    letterSpacing: '-0.01em',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    _hover: { textDecoration: 'none' },
  },
})

const LogoMark = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    borderRadius: 'sm',
    background:
      'linear-gradient(135deg, var(--colors-book-primary) 0%, #4F8DF8 100%)',
    color: '#fff',
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: 700,
    letterSpacing: '-0.04em',
  },
})

const NavLinks = styled('nav', {
  base: {
    display: { base: 'none', md: 'flex' },
    alignItems: 'center',
    gap: '28px',
  },
})

const NavLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 500,
    color: 'app.fgMuted',
    textDecoration: 'none',
    transition: 'color 160ms',
    _hover: { color: 'app.fg', textDecoration: 'none' },
    '&[data-active="true"]': { color: 'app.fg', fontWeight: 600 },
  },
})

const CtaButton = styled('a', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    backgroundColor: 'app.accent',
    paddingX: '18px',
    paddingY: '10px',
    borderRadius: 'pill',
    textDecoration: 'none',
    transition: 'background-color 160ms, transform 160ms',
    _hover: {
      backgroundColor: 'app.accentHover',
      textDecoration: 'none',
      transform: 'translateY(-1px)',
    },
  },
})

export { Nav, NavInner, LogoLink, LogoMark, NavLinks, NavLink, CtaButton }
